import { render, staticRenderFns } from "./MakeMold.vue?vue&type=template&id=603af144"
import script from "./MakeMold.vue?vue&type=script&lang=js"
export * from "./MakeMold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports